export enum ProblemSearchPanelActionTypes {
    FORM_SET_SOLVED = '@@problemSearchPanel/FORM_SET_SOLVED',
    FORM_SET_TITLE = '@@problemSearchPanel/FORM_SET_TITLE',
    FORM_SET_DIFFICULTY = '@@problemSearchPanel/FORM_SET_DIFFICULTY',
    FORM_SET_TAGS = '@@problemSearchPanel/FORM_SET_TAGS',
    FORM_SET_SORT = '@@problemSearchPanel/FORM_SET_SORT',
    FORM_SET_ORDER = '@@problemSearchPanel/FORM_SET_ORDER',
    FORM_SET_PAGE = '@@problemSearchPanel/FORM_SET_PAGE',
}
